import axios from 'axios';
import { BASE_URL } from '@/utils/constants';

/**
 * Refresh the access token using the refresh token
 * Note: We use a raw axios call (not the configured instance) to avoid interceptor loops
 */
export default async (refreshToken: string) => {
  const { data } = await axios({
    method: 'POST',
    baseURL: BASE_URL,
    url: '/api/auth/refresh',
    data: { refresh: refreshToken },
  });
  return data;
};

